import type { AxiosInstance } from 'axios';
import axios from 'axios';
import getConfig from 'next/config';

import { HEADERS } from '@sravni/server-utils/lib/consts';

import { errorTextContainEmailTemplateData } from '../../server/services/email/template/errorTextContainEmailTemplate';

import { createNetworkError } from './errorFabric';

export type HttpClientOptions = {
  baseUrl?: string;
};

// eslint-disable-next-line @typescript-eslint/no-extraneous-class
export class HttpClientEmail {
  private static _instance: AxiosInstance = (() => {
    const instance = axios.create({
      timeout: 50000,
      baseURL: getConfig().publicRuntimeConfig.apiPathUrl,
      responseType: 'json',
      withCredentials: true,
      headers: {
        // eslint-disable-next-line @typescript-eslint/naming-convention
        'Content-Type': 'application/json',
        Accept: 'application/json',
        // https://github.com/sravni/package-server-utils/blob/v0.4.0-beta.33/src/request/request.ts#L28
        ...(process.env.SERVICE_NAME ? { [HEADERS.CALLER_ID]: process.env.SERVICE_NAME } : {}),
      },
    });

    instance.interceptors.response.use(
      (_) => _,
      (error) => {
        if (error) {
          if (!error.response) {
            return Promise.reject(createNetworkError(error?.status || 500, { message: error.message }));
          }

          const { status, data } = error.response;
          const { message, error: errorFromServer } = data;

          return Promise.reject(createNetworkError(status, { message: message || errorFromServer?.message }));
        }

        return Promise.reject(error);
      },
    );

    return instance;
  })();

  static async sendErrorTextForm(data: errorTextContainEmailTemplateData): Promise<void> {
    return await HttpClientEmail._instance.post('/error-text-email-send/', data);
  }
}
